import React, { useCallback, useEffect, useState } from 'react';

import styled from '@emotion/styled';

import { createReactRenderer } from 'helpers/react-renderer';

import { NotificationBadge } from './NotificationBadge';
import { getStorageNotificationTabKey, NOTIFICATION_STYLES } from './utils';

const TabBadgeWrapper = styled(NotificationBadge)`
  margin-left: 0.5rem;
  margin-right: 0;
`;

/**
 * Tab notification component for B2B/NuOrder features.
 *
 * This component listens to 'notification_tab' events and reads from
 * NOTIFICATION_TAB localStorage keys. It is separate from the tile
 * notification system used by MAS/billing notifications.
 */
export const TabNotification = ({ tabKey }: { tabKey: string }) => {
  const [count, setCount] = useState(0);

  const syncNotifications = useCallback(() => {
    const notificationKey = getStorageNotificationTabKey(tabKey);
    let notifications: any = window.localStorage.getItem(notificationKey);

    if (notifications === null) {
      notifications = 1;
      window.localStorage.setItem(notificationKey, JSON.stringify(notifications));
    }

    setCount(notifications);
  }, [tabKey]);

  useEffect(() => {
    window.addEventListener('notification_tab', syncNotifications);

    return () => window.removeEventListener('notification_tab', syncNotifications);
  }, [syncNotifications]);

  useEffect(() => {
    syncNotifications();
  }, [syncNotifications, tabKey]);

  if (count <= 0) {
    return null;
  }

  return <TabBadgeWrapper count={count} style={NOTIFICATION_STYLES.DANGER} />;
};

const RenderedComponent = createReactRenderer({
  component: TabNotification,
  selector: '[data-react-root="tab-nuorder-catalog-matches"]',
});

history.onChangeState(
  [
    {
      name: ['item.listings.items'],
      form_name: 'listing',
      id: undefined,
    },
  ],
  () => {
    RenderedComponent.mount();
  },
  () => {
    RenderedComponent.unmount();
  }
);
